import { ShopCountry } from '@cbgms/base/shop-id'
import { VehicleProvider } from '@cbgms/api'

export const useGetBrandsCacheKey = (provider: VehicleProvider, country: ShopCountry) => ['GET', 'BRANDS', provider, country]

export const useGetModelsCacheKey = (provider: VehicleProvider, country: ShopCountry, brandKey?: string) => [
  'GET',
  'MODELS',
  provider,
  country,
  brandKey
]

export const useGetTypesCacheKey = (provider: VehicleProvider, country: ShopCountry, brandKey?: string, modelKey?: string) => [
  'GET',
  'TYPES',
  provider,
  country,
  brandKey,
  modelKey
]
